export default new class Popup {
    constructor() {
        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        let _this = this;

        document.addEventListener('click', function(e) {
            let link = null;
            //открытие попапа
            if (link = e.target.closest('.popup-link')) {
                e.preventDefault();
                let id = link.getAttribute('id');
                if(id) {
                    _this.popupMenuOpen(id);

                    // запоминаем какой попап показать в конце (например после регистрации в корзине)
                    _this.nextPopup = link.dataset.nextPopup || _this.nextPopup;
                }
                else {
                    console.log('такого модального окна не существует');
                }
                return;
            }

            if (_this.isOpen) {

                if (e.target.closest('.popup__close')) {
                    this.nextPopup = null;
                    _this.popupMenuClose();
                }


                if (e.target.closest('.popup__content') ) {
                    // клик внутри элемента
                    return;
                }

                _this.nextPopup = null;
                _this.popupMenuClose();
            }

        });


    }

    //закрытие попапа
    popupMenuClose() {
        document.querySelectorAll('.popup').forEach((el) => {
            el.style.display="none";
            const formEl = el.querySelector('form');
            if (formEl) {
                formEl.reset();
            }
            document.body.classList.remove('oc-hidden');
        });
        this.isOpen = false;
    }
    //открытие попапа
    popupMenuOpen(id, data = null) {
        this.popupMenuClose();
        this.isOpen = true;
        const popup = document.querySelector('.popup[id="'+id+'"]');

        if(id == 'sign_detailing_success') {
            popup.querySelector('.text-name').innerText = data.name;
            popup.querySelector('.text-phone').innerText = data.phone;
            popup.querySelector('.text-car').innerText = data.car_marka + ' ' + data.car_model;
        }

        popup.style.display="flex";
        document.body.classList.add('oc-hidden');
    }

}();